import React, { useState, useEffect } from 'react';
import callGetApi from "../../../requests/GetRequests";
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import { Modal } from 'carbon-components-react';
import { IncidentDetailsTabComponent } from '../IncidentDetailsTabComponent';
import IncidentsUserTabComponent from '../IncidentsUserTabComponent';
import * as IncidentDetailsConstants from './IncidentDetailsConstants';
import * as workspaces from '../../../config/WorkspaceConstants';

const IncidentDetailsTab = (props) => {
	const [incidentArrayLastExceptions,setIncidentArrayLastExceptions] = useState([]);
	const [somClassificationData, setSomClassificationData] = useState({});

	useEffect(() => {
		if(props.incidentDetailsData) {
			getIncidentDetailsRCA();
			if((window.location.pathname.indexOf('UserIncidentDetails') !== -1)) {
				getSomIncidentDetails(props.incidentDetailsData.number);
			}
		}
    }, [props.incidentDetailsData]);

	const getIncidentDetailsRCA = () => {
		let url = Constants.GETINCIDENTDETAILSRCAURL + props.sysId;
		callGetApi(url, {
			'Content-Type': 'application/json'
		}).then(response => {
			setIncidentArrayLastExceptions(response);
		}).catch(error => {
		});
	};

	const getSomIncidentDetails = (incidentId) => {
		// let bodyJSON = {};
		// let mustArray = [];
		// let payload = {"term":{"incident_id.keyword": {"value": incidentId}}};
		// mustArray.push(payload);
		// mustArray.push( {term: {active: {value: true}}})
		// bodyJSON.mustArray = mustArray;
		// bodyJSON.mustNotArray = [];
		// callPostApi(Constants.GETSAPFORSMARTOPS, {
		//   'Content-Type': 'application/json'
		// }, bodyJSON)
		// .then(resp => {
		//   if(resp.body) {
		// 	setSomClassificationData(resp.body.hits.hits[0]._source.classification);
		//   }
		// }).catch((error) => {
		//   console.error('Error:', error);
		// });

		let bodyJSON = {
			"incidentId": incidentId,
			"workspace": props.workspace,
			"alertType": props.alertType,
			"partyName": props.client

		};

        if (window.location.pathname.indexOf('UserIncidentDetails') !== -1 && props.workspace === workspaces.salesforce_ops) {
            bodyJSON.status = "IncidentsUser";
        }

		return callPostApi(Constants.GETCUSTOMFIELDSFORINCIDENTDETAILS, {
			'Content-Type': 'application/json'
		}, bodyJSON)
			.then(response => {
				if(response.body) {
						setSomClassificationData(response.body.hits.hits[0]._source.classification);
					  }
			}).catch(error => {
			});
	};

	return(
		<div className="page-margin">
			{props.incidentDetailsData &&
				(window.location.pathname.indexOf('UserIncidentDetails') !== -1)
				?
				<IncidentsUserTabComponent
					sysId={props.sysId}
					alertType={props.alertType}
					jobId={props.incidentDetailsData.u_jobid}
					incidentId={props.incidentDetailsData.number}
					incidentArray = {props.incidentDetailsData}
					incidentArrayLastExceptions = {incidentArrayLastExceptions}
					somClassificationData= {somClassificationData}
					disableIncidentUpdate={props.disableIncidentUpdate}
					updateSomData = {props.updateSomData}
					workspace={props.workspace}
					client={props.client}
					franchise={props.franchise}
                    getIncidentDetails = {props.getIncidentDetails}
                    getClassificationStatus={props.getClassificationStatus}
           		/>
				:
				<IncidentDetailsTabComponent
					sysId={props.sysId}
					alertType={props.alertType}
					jobId={props.incidentDetailsData.u_jobid}
					incidentId={props.incidentDetailsData.number}
					incidentArray = {props.incidentDetailsData}
					incidentArrayLastExceptions = {incidentArrayLastExceptions}
					selectedEntity={props.selectedEntity}
					aiopsInfo={props.aiopsInfo ? props.aiopsInfo.provider : ''}
					disableIncidentUpdate={props.disableIncidentUpdate}
					workspace={props.workspace} 
					client={props.client} 
					franchise={props.franchise}
                    getIncidentDetails = {props.getIncidentDetails}
					Queue={props.Queue}
					IncidentQueue={props.IncidentQueue}
					AppHostMachineName={props.AppHostMachineName}
				/>
			}
			<Modal
				passiveModal
				open={props.showSomUpdateIncidentWarningModal}
				size="xs"
				modalHeading={IncidentDetailsConstants.UpdateIncident}
				onRequestClose={props.closeSomUpdateIncidentWarningModal}
				>
			  {IncidentDetailsConstants.ValueCannotBeUpdated} {props.somFieldToBeUpdated === 'category' ? 'category' : 'assignment group'} {IncidentDetailsConstants.ValueCannotBeUpdated}.
			</Modal>
		</div>
	);
};

export default IncidentDetailsTab;